import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import MoneyRecordItem from './MoneyRecordItem';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

export default class MoneyRecordContainer extends Component {
    records = [];
    nomore = false;
    oninit(vnode) {
        super.oninit(vnode);
        this.loadDatas();
    }

    oncreate(vnode) {
        super.oncreate(vnode);
    }

    onupdate(vnode) {
        super.onupdate(vnode);
    }

    view() {
        return (
            <div className="money-record-container">
                <ul className="money-record-list">
                    {this.records.map((record) => {
                        return (
                            <li key={record.id} data-id={record.id}>
                                {MoneyRecordItem.component({record})}
                                <hr/>
                            </li>
                        );
                    })}
                </ul>

                {this.loading && (
                    <LoadingIndicator display="block"/>
                )}

                {!this.loading && !this.nomore && (
                    <div style="text-align:center;padding:20px">
                        <Button className={'Button Button--primary'} disabled={this.loading} loading={this.loading}
                                onclick={() => this.loadMore()}>
                            {app.translator.trans('xypp-money-more.forum.page.load-more')}
                        </Button>
                    </div>
                )}

                {this.nomore && (
                    <div style="text-align:center;padding:20px">
                        <span>{app.translator.trans('xypp-money-more.forum.page.no-more-records')}</span>
                    </div>
                )}
            </div>
        );
    }

    async loadDatas(page = 0) {
        this.loading = true;
        this.page = page;
        app.request({
            url: app.forum.attribute('apiUrl') + '/money-more/record/:id',
            params: {
                id: this.attrs.params.user.id(),
                page: page
            },
            method: 'GET'
        }).then((result) => {
            this.loading = false;
            if (result.data.length < 10) {
                this.nomore = true;
            }
            this.records = this.records.concat(result.data);
            m.redraw();
        }).catch((e) => {
            this.loading = false;
        });
    }

    loadMore() {
        this.loadDatas(this.page + 1);
    }
}
